import { handlerDDConfig, handlerFeiShuConfig, handlerWWConfig } from '@/utils/common/thirdPartyAuth.js';
import PermissionManager from '@/utils/permission';
import app from '@/common/public.js';
import { platConfig } from '@/common/config/platConfig.js';

let isIos;



const permissionManager = new PermissionManager(isIos);

import * as dd from 'dingtalk-jsapi';
import 'dingtalk-jsapi/entry/mobile';
import * as ww from '@wecom/jssdk';
import * as Sentry from '@sentry/vue';


/**
 * 获取定位内容
 * @param {定位类型}  type
 * @returns
 */
function getLocation({

  type = 'wgs84',




} = {}) {
  return new Promise(async (resolve, reject) => {
    try {
      const state = await permissionManager.requestApplicationPermission('location');
      if (!state) {
        return;
      }
      uni.getLocation({
        type: type,
        success: (res) => {
          // console.log('走了uni的定位', res);
          let settings = app.GetSettings();
          resolve(res);
        },
        fail: (res) => {

          let settings = app.GetSettings();
          Sentry.captureMessage(
            '【定位fail信息】' + JSON.stringify(res) + '【企业信息】' + settings.CompanyName + settings.CustomerName,
          );

          reject(res);
        },
      });
    } catch (error) {

      let settings = app.GetSettings();
      Sentry.captureMessage(
        '【定位error信息】' + JSON.stringify(res) + '【企业信息】' + settings.CompanyName + settings.CustomerName,
      );

      reject(error);
    }
  });
}

function getLocationDD() {
  const args = Array.prototype.slice.call(arguments);
  return new Promise((resolve, reject) => {
    handlerDDConfig()
      .then(() => {
        dd.device.geolocation.get({
          useCache: false, // 是否缓存地理位置信息，默认是true。若为true，客户端会对定位的地理位置信息缓存，在缓存期内 (2分钟) 再次定位会返回旧的定位。
          coordinate: 1, // 1：获取高德坐标  0：获取标准坐标
          withReGeocode: true, // 是否需要带有逆地理编码信息。
          targetAccuracy: 50, // 期望定位精度半径(单位米)，定位结果尽量满足该参数要求，但是不一定能保证小于该误差，开发者需要读取返回结果的 accuracy 字段校验坐标精度。
          onSuccess: (res) => {
            // console.log('dd.device.geolocation.get success', res);
            res.type = 'gcj02'; // 使用高德坐标系需要设置坐标类型
            resolve(res);
          },
          onFail: () => {
            // 如果获取钉钉定位失败，走一遍uniapp获取定位的流程
            getLocation(...args)
              .then((rest) => {
                resolve(rest);
              })
              .catch((error) => {
                reject(error);
              });
          },
        });
      })
      .catch(() => {
        // 如果获取钉钉定位失败，走一遍uniapp获取定位的流程
        getLocation(...args)
          .then((rest) => {
            resolve(rest);
          })
          .catch((error) => {
            reject(error);
          });
      });
  });
}

// 企业微信
function getLocationWW() {
  const args = Array.prototype.slice.call(arguments);
  return new Promise((resolve, reject) => {
    handlerWWConfig()
      .then(() => {
        // 调用 register 后可以立刻调用其他 JS 接口
        ww.getLocation({
          type: 'gcj02',
          success(res) {
            // console.log('ww.getLocation success', res);
            res.type = 'gcj02'; // 使用高德坐标系需要设置坐标类型
            resolve(res);
          },
          fail() {
            // 如果获取钉钉定位失败，走一遍uniapp获取定位的流程
            getLocation(...args)
              .then((rest) => {
                resolve(rest);
              })
              .catch((error) => {
                reject(error);
              });
          },
        });
      })
      .catch(() => {
        // 如果获取钉钉定位失败，走一遍uniapp获取定位的流程
        getLocation(...args)
          .then((rest) => {
            resolve(rest);
          })
          .catch((error) => {
            reject(error);
          });
      });
  });
}

function getLocationFeiShu() {
  const args = Array.prototype.slice.call(arguments);
  return new Promise((resolve, reject) => {
    handlerFeiShuConfig()
      .then(() => {
        tt.getLocation({
          type: 'gcj02',
          timeout: 5, // 定位超时时间
          cacheTimeout: 0, // 定位缓存超时时间，单位：秒
          accuracy: 'best', // 指定期望精度，支持 high、best; high：期望精度值为 100 m。high：best：期望精度值为 20 m。
          success(res) {
            resolve(res);
          },
          fail() {
            // 如果获取飞书定位失败，走一遍uniapp获取定位的流程
            getLocation(...args)
              .then((rest) => {
                resolve(rest);
              })
              .catch((error) => {
                reject(error);
              });
          },
        });
      })
      .catch(() => {
        // 如果获取飞书定位失败，走一遍uniapp获取定位的流程
        getLocation(...args)
          .then((rest) => {
            resolve(rest);
          })
          .catch((error) => {
            reject(error);
          });
      });
  });
}

function isDDEnterprise() {
  let isApp = false;




  if (isApp) {
    return false;
  } else {
    let settings = app.GetSettings();
    // 判断是否是钉钉平台
    if (Number(settings.platId) === platConfig.dingding && dd.env.platform != 'notInDingTalk' && settings.isLogin) {
      return true;
    } else {
      // 默认走uniapp的getLocation方法
      return false;
    }
  }
}

function isWWEnterprise() {
  let isApp = false;




  if (isApp) {
    return false;
  } else {
    let settings = app.GetSettings();
    // 判断是否是企业微信平台
    if (Number(settings.platId) === platConfig.qiyeweixin && ww && ww.env && ww.env.isWeCom && settings.isLogin) {
      return true;
    } else {
      // 默认走uniapp的getLocation方法
      return false;
    }
  }
}

function getPublicLocation() {
  const args = Array.prototype.slice.call(arguments);
  if (isDDEnterprise()) {
    return getLocationDD(...args);
  } else if (isWWEnterprise()) {
    return getLocationWW(...args);
  } else {
    return getLocation(...args);
  }
}

export { getPublicLocation, isDDEnterprise };
